module.exports = __webpack_public_path__ + "img/cat-09.da3f8880.png";